import { Component } from '@angular/core';
import { createSelector, Store } from '@ngrx/store';

import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { LibModule } from 'src/app/lib.ts/lib.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { brandingFeature } from 'src/app/state/branding.store';
import { preventKeyboardOnInputNumberButtonPress } from 'src/app/utilities/input.util';

import { getProductsWithClosestPricesByJobZone } from '../../job-charges-helpers';
import { ChargeWithQuantity } from '../../job-create/job-interfaces';
import { selectJob, selectJobLoading } from '../../job-tool.reducer';
import { JobMutateChargesComponent } from '../../mutate-charges/mutate-charges.component';
import { mutateObjectFeature } from '../../mutate-object/mutate-object.feature';
import { WorkOrdersActions } from '../job-workorders.actions';
import { jobWorkordersFeature } from '../job-workorders.feature';


@Component({
    selector: 'app-add-charges',
    standalone: true,
    imports: [
        FreyaCommonModule,
        SharedModule,
        LibModule,
        JobMutateChargesComponent,
    ],
    templateUrl: './add-charges.component.html',
    styleUrls: ['./add-charges.component.scss']
})


export class AddChargesComponent {
    viewModel$ = this.store.select(createSelector({
        job: selectJob,
        jobLoading: selectJobLoading,
        availableProducts: createSelector(
            brandingFeature.selectProducts,
            selectJob,
            jobWorkordersFeature.selectAddChargesDialog,
            (
              availableProducts,
              job,
              { selectedProducts },
            ) => getProductsWithClosestPricesByJobZone(availableProducts, job?.zone).map((p) => ({
              ...p,
              quantity: selectedProducts[p.id] || 0,
            })),
        ),
        productsLoading: brandingFeature.selectLoading,
        event: createSelector(
            jobWorkordersFeature.selectWorkordersEditor,
            jobWorkordersFeature.selectAddChargesDialog,
            ({ workorders }, { selectedEventId }) => {
                return workorders?.find((wo) => wo.eventId === selectedEventId);
            }
        ),
        visible: createSelector(
            jobWorkordersFeature.selectAddChargesDialog,
            mutateObjectFeature.selectMutateObjectDialog,
            ({ selectedEventId }, { activeMutator }) => Boolean(selectedEventId) && !activeMutator,
        ),
        productSearch: createSelector(jobWorkordersFeature.selectAddChargesDialog, ({ productSearch }) => productSearch),
    }));

    constructor(
        public store: Store,
    ) { }

    public actions = WorkOrdersActions;

    handleInputClick(event: any) {
        event.stopPropagation();
        const target = event.target as HTMLElement;
        if (target.tagName === 'BUTTON' || target.closest('button')) {
            const input = (target.closest('.p-inputnumber') as HTMLElement)?.querySelector('input') as HTMLInputElement;
            input?.blur();
        } else if (typeof (target as any).select === 'function') {
            (target as any).select();
        }
    }

    handleInputTouchStart(event: TouchEvent) {
        preventKeyboardOnInputNumberButtonPress(event);
    }

    productTrackBy(index: number, item: ChargeWithQuantity) {
      return item.id;
    }
}
